import { Circle, Image, Flex } from '@chakra-ui/react';
import { DialogRoot, DialogContent } from '@/components/ui/dialog';
import { FiX } from 'react-icons/fi';
import { useWidgetPortalProps } from '@/features/widget/hooks/widget-modal-hooks';

interface ImagePreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string | null;
}

export function ImagePreviewModal({
  isOpen,
  onClose,
  imageUrl,
}: ImagePreviewModalProps) {
  const portalProps = useWidgetPortalProps();

  // Check if the image is a profile picture (usually smaller and squarish)
  const isProfilePicture =
    imageUrl?.includes('/w=100&h=100') || imageUrl?.includes('photo-');

  // If the image is a placeholder, don't show the modal
  const isPlaceholder = !imageUrl?.includes('http');

  return (
    <DialogRoot
      open={isPlaceholder ? false : isOpen}
      onOpenChange={onClose}
      closeOnInteractOutside={false}
      {...portalProps}
    >
      <DialogContent
        bg="transparent"
        boxShadow="none"
        maxW="90vw"
        maxH="90vh"
        position="relative"
      >
        <Flex justifyContent="center" alignItems="center" h="100%" w="100%">
          {imageUrl && (
            <Flex position="relative" display="inline-flex">
              {/* Close button positioned at the corner of the image */}
              <Circle
                size="40px"
                bg="blackAlpha.700"
                color="white"
                cursor={'pointer'}
                onClick={onClose}
                _hover={{ bg: 'blackAlpha.800' }}
                position="absolute"
                top={-2}
                right={-2}
                zIndex={2}
              >
                <FiX size={20} />
              </Circle>

              <Image
                src={imageUrl}
                alt="Preview"
                maxW={isProfilePicture ? '400px' : '90vw'}
                maxH={isProfilePicture ? '400px' : '80vh'}
                minW={isProfilePicture ? '300px' : 'auto'}
                minH={isProfilePicture ? '300px' : 'auto'}
                objectFit={isProfilePicture ? 'cover' : 'contain'}
                borderRadius="md"
                boxShadow="xl"
              />
            </Flex>
          )}
        </Flex>
      </DialogContent>
    </DialogRoot>
  );
}
